import { CheckboxIntermediateVariantIcon } from './CheckboxIntermediateVariantIcon';

/**
 * author: Andy Giesen
 * id 409261FA-D055-4E16-88A0-94C31667F218
 * name checkbox-intermediate-variant
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-intermediate-variant.svg
 * tags
 * - Form 
 */
export const CheckboxIndeterminateVariantIcon = CheckboxIntermediateVariantIcon;
export default CheckboxIndeterminateVariantIcon